export default __webpack_public_path__ + "static/media/puzzle_2.f702e1d5.png";